import React, { useRef, useEffect, useMemo } from "react";
import { Container } from "@pixi/react";
import RoyalCollectReelFrontController, {
  SPINE_CONFIG,
} from "./RoyalCollectReelFrontController";
import { Settings } from "../../settings";
import { useReelRefs } from "../../Contexts/ReelRefsContext";
import { useSlotRegistry } from "../../Contexts/SlotRegistryContext";

const RoyalCollectReelFront = ({
  symbolWidth,
  symbolHeight,
  dimensions,
  dividerDimensions,
}) => {
  const reelFrontControllerRef = useRef(null);
  const spriteRef = useRef(null);
  const { royalCollectReelFrontControllerRef } = useReelRefs();
  const slotRegistry = useSlotRegistry();

  useEffect(() => {
    if (spriteRef.current && !reelFrontControllerRef.current) {
      reelFrontControllerRef.current = new RoyalCollectReelFrontController(
        spriteRef.current,
        symbolWidth,
        symbolHeight,
        dimensions,
        dividerDimensions,
        slotRegistry,
      );
      // Expose controller via context for respin counter access
      royalCollectReelFrontControllerRef.current = reelFrontControllerRef.current;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (reelFrontControllerRef.current) {
      reelFrontControllerRef.current.resizeReelFront(
        symbolWidth,
        symbolHeight,
        dimensions,
        dividerDimensions,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbolHeight]);

  const containerPosition = useMemo(() => ({
    x: symbolWidth * Settings.REEL_COUNT * SPINE_CONFIG.horizontalOffset,
    y: -symbolHeight * Settings.SYMBOLS_VISIBLE * SPINE_CONFIG.verticalOffset,
  }), [symbolWidth, symbolHeight]);

  return (
    <Container
      y={containerPosition.y}
      x={containerPosition.x}
      ref={spriteRef}
      name="royal_collect_front_texture"
      zIndex={7}
      sortableChildren={true}
    >
    </Container>
  );
};

export default RoyalCollectReelFront;
